module.exports = __webpack_public_path__ + "img/start.f43f033b.svg";